export const robotenJsonataSingleRegExp = /^({{)(.|\n)*(}})$/
export const robotenJsonataMultipleRegExp = /(.|\n)*({{)(.|\n)*(}})(.|\n)*/
export const robotenJsonataPathRegExp =
  /^\{{2}\s*(\$\.)?(((['"\`]?)[a-zA-Z_][a-zA-Z_0-9]*\4)|(\[[0-9]*\]))(\.((['"\`]?)[a-zA-Z_][a-zA-Z_0-9]*\8)|(\[[0-9]*\]))*\s*\}{2}$/

export const addRobotenFormats = <
  T extends { addFormat: (name: string, pattern: RegExp) => void }
>(
  ajv: T
): T => {
  ajv.addFormat('roboten-jsonata-single', robotenJsonataSingleRegExp)
  ajv.addFormat('roboten-jsonata-multiple', robotenJsonataMultipleRegExp)
  ajv.addFormat('roboten-jsonata-path', robotenJsonataPathRegExp)
  return ajv
}
